import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import Reducer from '../reducers';
import { composeWithDevTools } from 'redux-devtools-extension';

const store = createStore( Reducer,composeWithDevTools(applyMiddleware(thunkMiddleware)));

export type AppState = ReturnType<typeof Reducer>;
export default store;
